<button 
  type="button" 
  class="toast-close-button" 
  (click)="remove()"
  #closeBtn
  tabindex="0"
  [attr.aria-label]="'Close ' + (title || 'notification')"
>
  <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title" class="toast-title">{{ title }}</div>
<div class="toast-message" [innerHTML]="message"></div>
